import differenceInHours from 'date-fns/differenceInHours';
import differenceInMinutes from 'date-fns/differenceInMinutes';
import differenceInSeconds from 'date-fns/differenceInSeconds';

export function getTimeDifference(endDate: Date, startDate: Date) {
  const seconds = (differenceInSeconds(endDate, startDate) % 60).toString().padStart(2, '0');
  const minutes = (differenceInMinutes(endDate, startDate) % 60).toString().padStart(2, '0');
  const hours = differenceInHours(endDate, startDate).toString().padStart(2, '0');

  return {
    hours,
    minutes,
    seconds,
  };
}

export function getDifferenceInDays(startDateGMT, endDateGMT) {
  // Convert the GMT dates to UTC
  const startDateUTC = new Date(startDateGMT).getTime();
  const endDateUTC = new Date(endDateGMT).getTime();

  // Calculate the difference in milliseconds
  const differenceInMs = endDateUTC - startDateUTC;

  // Convert milliseconds to days
  const differenceInDays =
    differenceInMs !== 0 ? Math.floor(differenceInMs / (1000 * 60 * 60 * 24)) : 0;

  return differenceInDays;
}
export const calculateTimeInHours = ({
  time,
  format,
}: {
  time: number;
  format: 'string' | 'clock';
}) => {
  const hours = Math.floor(time / 60);
  const minutes = time % 60;

  return `${
    format === 'string'
      ? `${minutes === 0 ? `${hours}h` : `${hours}h ${minutes}m`}`
      : `${hours}:${minutes.toString().padStart(2, '0')}`
  }`;
};

export function isStartDateGreater(startDateStr, endDateStr) {
  // Create Date objects in GMT format
  const startDate = new Date(startDateStr);
  const endDate = new Date(endDateStr);

  // Compare dates
  if (startDate > endDate) return true;
  else return false;
}

//export const calculateTimeInHours = ({
//   time,
//   format = 'string',
// }: {
//   time: number;
//   format?: 'clock' | 'string';
// }) => {
//   const hours = Math.floor(time / 60);
//   const minutes = time % 60;
//   return `${hours}h ${minutes}m`;
// };
